<div class="container">
  <mat-toolbar><h3>Edit User Setting</h3></mat-toolbar>

  <mat-card>
    <mat-card-content>
      <ng-container *ngIf="Uprops">
        <!-- Module -->
        <div class="wrapper">
          <label class="label">Module</label>
          <mat-form-field>
            <input
              matInput
              [(ngModel)]="Uprops.modulename"
              [ngModelOptions]="{ standalone: true }" />
          </mat-form-field>
        </div>
        <!-- Setting -->
        <div class="wrapper">
          <label class="label">Setting</label>
          <mat-form-field>
            <input
              matInput
              [(ngModel)]="Uprops.property"
              [ngModelOptions]="{ standalone: true }" />
          </mat-form-field>
        </div>
        <!-- Value -->
        <div class="wrapper">
          <label class="label">Value</label>
          <mat-form-field>
            <input
              matInput
              [(ngModel)]="Uprops.propertyvalue"
              [ngModelOptions]="{ standalone: true }" />
          </mat-form-field>
        </div>

        <mat-card-actions class="buttonspace">
          <button
            mat-raised-button
            mat-button
            color="primary"
            (click)="editUserproperties()">
            Save
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="clear()">
            Reset
          </button>
        </mat-card-actions>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
